<template>
  <div class="select-common">
    <div class="body-wrapper">
      <div class="scroll-wrapper" key="common-scroll-wrapper" v-ps>
        <div v-if="groupedOptionsFiltered.length == 0">没有搜索结果，请变更搜索条件</div>
        <el-checkbox-group v-else :value="selected.map(t => t.value)">
          <div v-for="group in groupedOptionsFiltered" :key="group.label" class="option-group">
            <div class="group-name">{{ group.label }}</div>
            <div class="options">
              <el-checkbox
                v-for="o in group.options"
                :key="o.id"
                :label="o.id"
                @change="change($event, [o.id], group.value)"
              >
                {{ o.name }}
              </el-checkbox>
            </div>
          </div>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchList",
  props: {
    searchText: String,
    selected: {
      type: Array,
      default: () => []
    },
    groupedOptions: {
      type: Array,
      default: () => [
        {
          label: "人员",
          value: "user",
          options: [{ id: "1", name: "测试" }]
        }
      ]
    }
  },
  data() {
    return {}
  },
  computed: {
    groupedOptionsFiltered() {
      if (!this.searchText) return this.groupedOptions
      let groups = []
      for (const { label, value, options } of this.groupedOptions) {
        let filteredOptions = options.filter(option => option.name.indexOf(this.searchText) >= 0)
        if (filteredOptions.length > 0) {
          groups.push({ label, value, options: filteredOptions })
        }
      }
      return groups
    }
  },
  methods: {
    change(isAdd, ids, groupValue) {
      this.$emit("change", { isAdd, ids }, groupValue)
    },
    selectFirst() {
      let firstGroup = this.groupedOptionsFiltered[0]
      if (!firstGroup) return
      let firstOption = this.groupedOptionsFiltered[0]?.options?.[0]
      let isAdd = this.selected.find(t => t.value === firstOption.id) === undefined
      this.$emit("change", { isAdd, ids: [firstOption.id] }, firstGroup.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-common {
  .body-wrapper {
    padding: 6px 6px 6px 12px;
    .breadcrumb {
      display: flex;
      overflow: hidden;
      .breadcrumb-item {
        display: flex;
        flex: 0 0 auto;
        .text {
          color: #407fff;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        &:last-of-type {
          .text {
            color: unset;
            cursor: unset;
            &:hover {
              text-decoration: unset;
            }
          }
        }
      }
    }
  }
  .scroll-wrapper {
    max-height: 200px;
    min-height: 50px;
    position: relative;
    .option-group {
      .group-name {
        font-size: 14px;
        color: #c1c5ce;
      }
    }
    .el-checkbox-group {
      display: flex;
      flex-flow: column;
      /*自定义文字显示*/
      .checkbox-wrapper {
        display: flex;
        position: relative;
        align-items: center;
        height: 40px;
        .name-wrapper {
          height: 100%;
          flex: 1;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
        .el-icon-arrow-right {
          font-size: 14px;
          position: absolute;
          right: 0px;
          top: 12px;
        }
        &:hover {
          background-color: #f0f4fd;
        }
      }
      .el-checkbox {
        display: flex;
        align-items: center;
        margin-right: 0;
        height: 40px;
        &:hover {
          background-color: #f0f4fd;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          align-items: center;
          .avatar {
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
